import React from 'react';
import _isEqual from 'fast-deep-equal'
import { Box, TextField, Typography } from '@mui/material';
import { connect } from 'react-redux';
import PropTypes from 'prop-types'
import Select from 'react-select';
import '../App.css'

// API Method Call
import { fetchPlaceByUcode } from '../utils/fetchUtils'

// import actions and reducers
import { setHomePanelName } from '../Redux/Reducers/commonReducer'
import { setSelectedDistrictForFilter, setFilteredData, setFilterStartDate, setFilterEndDate } from '../Redux/Reducers/filterReducer'
import { fetchCnlFilteredData, fetchData, fetchRetailFilteredData } from '../Redux/Actions/mapDataActions'
import { setRunLoader, setRenderSinglePoint, setSingleDataPoint } from '../Redux/Reducers/mapDataReducer'
import { getGeneratedTaskMessage, getGeneratedTaskMessageCnl } from '../Redux/Actions/commonAction'

// import components
import StyledDateRangePicker from './StyledDateRangePicker'
import { LoadingButton } from '@mui/lab';
import { getOutletCategories } from '../Redux/Actions/cnlActions';
import { setAddedShopCount, setUpdatedShopCount } from '../Redux/Reducers/cnlReducer';

class FilterPanelCnl extends React.PureComponent {
    state={
        selectedStateDistrict: '',
        allDistrictWithoutAllOption: [],
        isLoading: false,
        onStateFilteredData: [],
        territoryId: '',
        routeId: '',
        outletCategory: '',
        localAddedDataCount: 0,
        localUpdatedDataCount: 0,
        startDateType: 0
    }

    //keeping track of current tab to show data respective data in MAP 
    componentDidMount(){
        const { dispatch, allDistrict, filteredData } = this.props
        dispatch(setHomePanelName('filter'))

        // discarding all option from district list
        const districtWithoutAllOption = allDistrict?.filter(item => item?.value !== 'All')
        this.setState({
            allDistrictWithoutAllOption: districtWithoutAllOption,
            onStateFilteredData: filteredData
        })

        dispatch(getOutletCategories());

    }

    componentDidUpdate(prevProps, prevState){
        const { filteredData, addedDataCount, updatedDataCount } = this.props

        // if filtered data of props get changed
        if( !_isEqual( prevProps.filteredData, filteredData ) ){
            this.setState({
                onStateFilteredData: filteredData
            })
        }
    }

     //keeping track of current tab by setting homePanelName empty to show data respective data in MAP 
    componentWillUnmount(){
        const {dispatch} = this.props
        dispatch(setFilteredData([]))
        dispatch(setSingleDataPoint([]))
        dispatch(setHomePanelName(''))
    }

    // dispatch changed district
    _handleDistrictChange = (e) => {
        const { dispatch } = this.props
        const newSelectedDistrict = e?.value ?? ''

        this.setState({
            selectedStateDistrict: newSelectedDistrict
        })

        dispatch(setSelectedDistrictForFilter(newSelectedDistrict))
    }

    // load data on filter button click
    _loadData = () => {
        const {dispatch, filterStartDate, filterEndDate } = this.props
        const { territoryId, routeId, outletCategory, startDateType } = this.state

        const params = {
            start_date: filterStartDate,
            end_date: filterEndDate,
            territory_id: territoryId ?? '',
            route_id: routeId ?? '',
            outlet_category: outletCategory ?? '',
            include_filter_by_created_at: startDateType ?? ''

        }

        console.log("params diskao", params);
        
        this.setState({
            isLoading: true
        })

        fetchCnlFilteredData(params)
        .then(res => {
            // if(res?.length > 0){
                dispatch(setFilteredData(res?.outlets))
                dispatch(setAddedShopCount(res?.total_outlet_count))
                dispatch(setUpdatedShopCount(res?.total_updated_outlet_count))
            // }
            this.setState({
                isLoading: false
            })

        })
        .catch(err => {
            console.error(err)
            this.setState({
                isLoading: false
            })
        })
    } 

    // get single point data, other data remains as it was. Store in reducer other than points
    // this is to show a single point data in map and open it's custop popup data while other data should also be visible as it was. Therefore, will store data in separated reducer instead of points
    _loadSeparatedSinglePointData = (e, uCode, index) => {
        const { dispatch } = this.props
        const { currentlySelectedNode } = this.state

        if(!uCode){
            return
        }

        dispatch(setRunLoader(true));

        fetchPlaceByUcode(uCode)
            .then(data => {

                dispatch(dispatch => {
                    dispatch(setRenderSinglePoint(true))
                    dispatch(setSingleDataPoint([data]))
                    // dispatch(setStaticPoints([data]))
                    dispatch(setRunLoader(false))
                })
                

            })
            .catch(err => {
                dispatch(setRunLoader(false));
                console.error(err)
            })

        // unmarking selected list data
        if(currentlySelectedNode){
            currentlySelectedNode.style.backgroundColor = 'white'
        } 

         // marking selected list data
        const domElem = e.target
        domElem.style.backgroundColor = '#c9daea'

        this.setState({
            currentlySelectedNode: domElem
        })
    }

    // update date
    _handleDateChange = (date) => {
        const { dispatch } = this.props
        if(date?.startDate){
            dispatch(setFilterStartDate(date?.startDate))
        }
        else if(date?.endDate){
            dispatch(setFilterEndDate(date?.endDate))
        }
    }

    // handleTerritoryId
    _handleTerritoryId = (e) => {
        let territoryId = e.value
        console.log("terr name", territoryId);
        this.setState({ territoryId })
    }

    // handlerouteId
    _handleRouteId = (e) => {
        let routeId = e.value
        console.log("routeId name", routeId);
        this.setState({ routeId })
    }

    // handleMarketName
    _handleOutletCategory = (e) => {
        let outletCategory = e.value
        console.log("outletCategory name", outletCategory);
        this.setState({ outletCategory })
    }

    _handleStartDateType = (e) => {
        let startDateType = e.value
        console.log("startDateType name", startDateType);
        this.setState({ startDateType })
    }

    // search data by keyword
    _onChangeSearch = ( e ) => {
        const { filteredData } = this.props
        const targetValue = e.target.value?.trim()?.toLowerCase()

        // if matched data is found
        const searchedData = filteredData?.filter( item => { 
            for( const [ _, value ] of Object.entries( item ) ){
                if( value && JSON.stringify(value)?.toLowerCase()?.includes( targetValue )){
                    return item
                }
            }   
        })

        this.setState({ 
            onStateFilteredData: searchedData
        })
    }

    render (){
        const { filterStartDate, filterEndDate, teritories, outletCategories, routes, updatedShopCount, addedShopCount} = this.props
        const { isLoading, outletTypes, selectedStateDistrict, allDistrictWithoutAllOption, localAddedDataCount, localUpdatedDataCount, onStateFilteredData } = this.state

        return (
            <Box sx={filterContainerStyle}>
                <div style={{padding: 0}}>
                    <StyledDateRangePicker 
                        filterPanelData={ true }
                        dateRange={{ start: filterStartDate, end: filterEndDate }}
                        handleDateChange={ this._handleDateChange }
                    />
                </div>
                <div style={dateInputContainerStyle}>
                    {/* <div style={dateItem}>
                        <label style={label} htmlFor='retail_size'>District:</label>
                        <Select
                            name={ 'retail_size' }
                            options={ allDistrictWithoutAllOption }
                            classNamePrefix={ 'select' }
                            onChange={ this._handleDistrictChange }
                            isClearable={ true }
                            styles={ customStyles }
                        />
                    </div> */}
                        <Box sx={
                            {
                            display:"flex",
                            width:"100%",
                            flexDirection:"row",
                            justifyContent: "center",
                            alignItems:"space-around"}
                        }>
                            <Select
                                name='teritories'
                                id='teritories'
                                options={teritories}                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          
                                // label='Market Opportunity'
                                onChange={this._handleTerritoryId}
                                placeholder="Territory Name                      "
                                // defaultValue={currentData?.market_opportunity }
                                isClearable={false}
                                styles={{
                                    control: (baseStyles, state) => ({
                                      ...baseStyles,
                                      minWidth: "100% !important",
                                    }),
                                }}
                            />

                            <Select
                                name='routes'
                                id='routes'
                                options={routes}
                                // label='Market Opportunity'
                                onChange={this._handleRouteId}
                                placeholder="Routes Name"
                                // defaultValue={currentData?.market_opportunity }
                                isClearable={false}
                            />
           
                            <Select
                                name='outlet_categories'
                                id='outlet_categories'
                                options={outletCategories}
                                // label='outletCategories'
                                onChange={this._handleOutletCategory}
                                placeholder="Outlet Categories"
                                // defaultValue={currentData?.market_opportunity }
                                isClearable={false}
                            />
                        </Box>

                        <br/>
                        <Box sx={{display: "flex", flexDirection: "row", justifyContent: "center", margin: "5px"}}>
                            <Typography ml={ 1 } mt={ 1 } fontSize={ 13 } variant={ 'body1' } htmlFor="outlet_categories">Start Date Type -  </Typography>
                            <Select
                                name='startDateType'
                                id='startDateType'
                                options={[
                                    {
                                        label: "Add Date",
                                        value: 1
                                    },
                                    {   label: "Update Date",
                                        value: 0
                                    }
                                ]}
                                // label='outletCategories'
                                onChange={this._handleStartDateType}
                                placeholder="Start Date Type"
                                defaultValue={
                                    {   label: "Update Date",
                                        value: 0
                                    }
                                }
                                isClearable={false}
                            />

                        </Box>

                          
                         
                          
                            {/* <input 
                                placeholder='Territory Name' 
                                type="text"
                                onChange={this._handleTerritoryId} 
                                style={{ 
                                    width: "90%", 
                                    margin: '2px',
                                    padding: '4px 10px', 
                                    borderRadius: '4px 0 0 4px', 
                                    border: '1px solid rgba(190, 190, 190, 0.76)' 
                                }} 
                            />
                            <input 
                                placeholder='Route Name' 
                                onChange={this._handleRouteId} 
                                type="text" 
                                style={{ 
                                    width: "90%", 
                                    padding: '4px 10px', 
                                    margin: '2px',
                                    borderRadius: '4px 0 0 4px', 
                                    border: '1px solid rgba(190, 190, 190, 0.76)' 
                                }} 
                            />

                            <input 
                                placeholder='Market Name' 
                                onChange={this._handleMarketName} 
                                type="text" 
                                {/* <input 
                                placeholder='Territory Name' 
                                type="text"
                                onChange={this._handleTerritoryId} 
                                style={{ 
                         include_filter_by_created_at           width: "90%", 
                                    margin: '2px',
                                    padding: '4px 10px', 
                                    borderRadius: '4px 0 0 4px', 
                                    border: '1px solid rgba(190, 190, 190, 0.76)' 
                                }} 
                            />
                            <input 
                                placeholder='Route Name' 
                                onChange={this._handleRouteId} 
                                type="text" 
                                  width: "90%", 
                                    padding: '4px 10px', 
                                    margin: '2px',
                                    borderRadius: '4px 0 0 4px', 
                                    border: '1px solid rgba(190, 190, 190, 0.76)' 
                                }} 
                            /> */}
                    <div style={{...dateItem, width: '100%'}}>
                        <LoadingButton
                            className={ 'toggleBtn' } 
                            variant={'contained'}
                            size={ 'small' }
                            onClick={ this._loadData }
                            loading={ isLoading }
                            sx={ buttonStyle } 
                            // disabled={ filterStartDate && filterStartDate ? false : true }
                        >
                            Filter
                        </LoadingButton>
                    </div>
                    {/* <div style={{ ...dateItem, width: '100%' }}>
                        <TextField
                            onChange={ this._onChangeSearch } 
                            label={ 'Search by keyword' } 
                            variant={ 'outlined' } 
                            fullWidth={ true }
                            size={ 'small' }
                            sx={{ fontSize: '12px !important', lineHeight: '16px', zIndex: 0 }}
                        />
                    </div> */}
                </div>

                {
                    <div style={{ textAlign: 'center', fontSize: "13px", display: "flex", flexDirection: "row" }}>
                        {/* <p style={{ margin:"0px", marginRight:"10px"}}>Total Data Count: <span style={{fontWeight: "bold", }}>{ onStateFilteredData?.length ?? 0 }</span></p> */}
                        <p style={{ margin:"0px",  marginRight:"10px"}}>Added Data Count: <span style={{fontWeight: "bold"}}>{ addedShopCount }</span></p>
                        <p style={{ margin:"0px"}}>Updated Data Count: <span style={{fontWeight: "bold"}}>{ updatedShopCount }</span></p>
                    </div>
                }
                {   onStateFilteredData?.length > 0 &&
                    <div style={{padding: '10px 0 30px 0', height: '100%'}}>
                        { 
                            onStateFilteredData?.map(( item, index ) => (
                                <p 
                                    onClick={ ( e ) => this._loadSeparatedSinglePointData( e, item?.uCode, index )} 
                                    value={ 'item?.uCode' } 
                                    key={ item?.uCode } 
                                    style={{
                                        cursor: 'pointer', 
                                        fontSize: '13px', 
                                        borderBottom: '1px solid #939aa0', 
                                        margin: 0, 
                                        padding: '3px 0',
                                        lineHeight: '17px'
                                    }}
                                >
                                    {
                                        getGeneratedTaskMessageCnl( item )
                                    }
                                </p>
                            ))
                        }
                    </div>
                }
         
          </Box>
        )
    }
}

const customStyles = {
    control: base => ({
        ...base,
        minHeight: 20,
    }),
    dropdownIndicator: base => ({
        ...base,
        padding: 2
    }),
    clearIndicator: base => ({
        ...base,
        padding: 2
    }),
    multiValue: base => ({
        ...base,
        // backgroundColor: 'red'
    }),
    valueContainer: base => ({
        ...base,
        padding: '0px 6px'
    }),
    input: base => ({
        ...base,
        margin: 0,
        padding: 0
    })
};


const filterContainerStyle = {
    overflowY: 'auto', 
    height:'100%', 
    maxHeight: `${window.innerHeight - 110}px`, 
    minWidth: '120px',  
    padding: '15px 15px 50px 15px', 
    fontSize: '16px',
    wordBreak: 'break-word',
}

const dateInputContainerStyle = {
  width: '100%',
  padding: '0',
  display: 'flex',
  justifyContent: 'flex-start',
  flexWrap: 'wrap',
  marginTop: '5px'
}
const dateItem = {
  width: '50%',
  paddingRight: '5px'
}

const label = {
  display: 'inline-block',
  textAlign: 'left',
  fontSize: '12px',
  paddingLeft: '1px',
}

const buttonStyle = {
  width: '100%', 
  height: '28px',
  margin: '10px auto' 
}

const fieldContainer ={
    display: 'flex',
    flexDirection: 'row'
}


// Prop Types
FilterPanelCnl.propTypes = {
    points: PropTypes.array,
    filteredData: PropTypes.array,
    allDistrict: PropTypes.array,
}
FilterPanelCnl.defaultProps = {
    points: [],
    filteredData: [],
    allDistrict: [],
}

const mapStateToProps = (state) => ({
    points: state?.mapData?.points ?? [],
    filteredData: state?.filter?.filteredData ?? '',
    allDistrict: state?.common?.allDistrict ?? [],
    filterStartDate: state?.filter?.filterStartDate ?? '',
    filterEndDate: state?.filter?.filterEndDate ?? '',
    startDate: state?.common?.startDate ?? '',
    endDate: state?.common?.endDate ?? '',
    outletTypes: state?.cnl.outletTypes ?? [],
    outletCategories: state?.cnl?.outletCategories ?? [],
    marketOpportunities: state?.cnl?.marketOpportunities ?? [],
    teritories: state?.cnl?.teritories ?? [],
    routes: state?.cnl?.routes ?? [],
    addedShopCount: state?.cnl?.addedShopCount ?? 0,
    updatedShopCount: state?.cnl?.updatedShopCount ?? 0
})
const mapDispatchToProps = (dispatch) => ({dispatch})
  
  export default connect(mapStateToProps, mapDispatchToProps)(FilterPanelCnl);